import React from 'react';

import Aux from '../../../hoc/Auxiliary';
import Backdrop from '../../UI/Backdrop/Backdrop';
import PopupBox from '../../UI/PopupBox/PopupBox';
import Button from '../../UI/Button/Button';

const listCheckedInUsers = (props) => {
    const list = [];
    for (let key in props.list) {
        list.push((<Button clicked={() => props.loadUser(props.list[key])} key={key}>{props.list[key]}</Button>));
    }

    return (
        <Aux>
            <Backdrop show={props.show} clicked={props.modalClicked} />
            <PopupBox>
                <div>
                    {list}
                </div>
            </PopupBox>
        </Aux>
    );
}

export default listCheckedInUsers;